import { Component, OnInit, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../core/auth/auth.service";
import { UserService } from "../../../core/user.service";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { CqmnsProjectPopupComponent } from "../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import swal from 'sweetalert2';
import { DOCUMENT } from '@angular/common';
import * as config from "../../../../../config.json";

@Component({
  selector: 'app-cqm-ns-navbar',
  templateUrl: './cqm-ns-navbar.component.html',
  styleUrls: ['./cqm-ns-navbar.component.css']
})
export class CqmNsNavbarComponent implements OnInit {
  username: any;
  role:any;
  projectId: any;
  hostUrl: any;
  currenturl :any;
  dashboardurl: string;
  value1: string;
  sourceDetails: any;
  sourceNames: any = [];
  assignTo =false;
  sentiment = false;
  userName:any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private userService: UserService,
    private matDialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
  )  { }

  ngOnInit() {
    this.hostUrl = this.userService.getUrl();
    //this.projectId = this.route.snapshot.params["projectId"];
    this.projectId = localStorage.getItem("projectId");
    this.userName = localStorage.getItem("name");
    if(this.projectId){
    this.http.get(encodeURI(this.hostUrl+'/configure/projectSourceId/' + this.projectId))
    .subscribe(data => {
      this.sourceDetails = data;
      for(let i =0; i<this.sourceDetails.length; i++){
        this.sourceNames.push(this.sourceDetails[i].source); 
       if( this.sourceNames.includes("Service Now") ||  this.sourceNames.includes("JIRA") || this.sourceNames.includes("Jira") || this.sourceNames.includes("EXCEL"))
        {
         this.assignTo = true;
        }   
        else {
         this.assignTo = false;
        }
        if( this.sourceNames.includes("IOS") ||  this.sourceNames.includes("Twitter") ||  this.sourceNames.includes("Play Store"))
        {
         this.sentiment = true; 
        }
        else {
         this.sentiment = false;
        }
     }
     });
    }
  }
  dashboard(){
    this.currenturl = 'dashboard';
    this.dashboardurl = "/cqm-ns" ;
    this.router.navigate([this.dashboardurl]);
  }
  upload() {
    const url = "/cqmns-upload-excel-defect";
    this.router.navigate([url]);
  }
  scan() {
    this.currenturl = 'actions';
    const url = "/cqmns-scan-defect" ;
    this.router.navigate([url]);
  }

  validate() {
    this.currenturl = 'actions';
   // localStorage.setItem('currentTab', this.currenturl);  
  //  this.currenturl = localStorage.getItem("currentTab");

    const url = "/cqmns-validate-defect" ;
    this.router.navigate([url]);
    
  }

  assignActions(value: any) {
   localStorage.setItem('currentTab', value);  
   this.currenturl = localStorage.getItem("currentTab");
  }

  returnCurrentUrl(){
    return this.currenturl;
  }


  approvedList() {
    this.currenturl = 'actions';
   // localStorage.setItem('currentTab', this.currenturl);  
   // this.currenturl = localStorage.getItem("currentTab");
    const url = "/cqmns-approved-defect" ;
    this.router.navigate([url]);
  }
  goToRca() {
    this.currenturl = 'actions';
    const url = "/cqmns-recommend-rca" ;
    this.router.navigate([url]);
  }
  goToApprovedRca() {
    this.currenturl = 'actions';
    const url = "/cqmns-approved-rca" ;
    this.router.navigate([url]);
  }
  goToSelectedRCA() {
    this.currenturl = 'actions';
    const url = "/cqmns-selected-rca" ;
    this.router.navigate([url]);
  }
  goToDefectAnalysis(){
    this.currenturl = 'actions';
    const url = "/cqm-ns-analyse-defects" ;
    this.router.navigate([url]);
  }
  goToDefectDuplication(){
    this.currenturl = 'actions';
    const url = "/cqm-ns-defects-duplications" ;
    this.router.navigate([url]);
  }
  // project(){
  //    const url = "/cqm-ns-analytics-dash/" + this.projectId;
  //   this.router.navigate([url]);
  // }
  project() {
    

      const dialogConfig = new MatDialogConfig();
  
      // dialogConfig.panelClass = "login-modalbox";
  
      dialogConfig.backdropClass = 'popupBackdropClass';
  
      dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 
  
      dialogConfig.panelClass = "ns-modalbox";
      dialogConfig.disableClose = false;
      this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

  }
  myFunction(val) {
    let url;
    if (val == "byDate") {
      this.currenturl = 'reports';
      url = "/cqmns-classification-trend-report" ;
    } else if (val == "bytotalclassified") {
      this.currenturl = 'reports';
      url = "/cqmns-total-vs-classified-report" ;
    } else if (val == "byrcafrequency") {
      this.currenturl = 'reports';
      url = "/cqmns-rca-frequency-report" ;
    } else if (val == "byrca") {
      this.currenturl = 'reports';
      url = "/cqmns-rca-trend-report" ;
    } 
    this.router.navigate([url]);
  }
  onLogOut() {
    swal({
        type:'success',
        width: 300,
        text: 'Logout successfull!',
        showConfirmButton: false,                   
        timer: 1500
  })
     this.authService.logout();
     this.document.location.href = config['scriptlessHome'];
  }
  backToNS(){
    this.document.location.href = config['scriptlessHome'];
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-navbar/cqm-ns-navbar.component.ts